import { instance } from './index';

export const assignGroupManager = async (groupId: number, loginId: string) => {
  await instance.post(`/store-admin/groups/${groupId}/managers`, { loginIds: [loginId] });
};

export const assignGroupManagers = async (groupId: number, loginIds: string[]) => {
  await instance.post(`/store-admin/groups/${groupId}/managers`, { loginIds });
};

export const unassignStoresFromGroup = async (groupId: number, storeIds: number[]) => {
  await instance.delete(`/store-admin/groups/${groupId}/stores`, { data: { storeIds } });
};

export const getStoreAdminAccess = async () => {
  const response = await instance.get('/store-admin/access');
  return response.data;
};

export const getStoreAdminStores = async (keyword?: string) => {
  const response = await instance.get('/store-admin/stores', { params: { keyword } });
  return response.data;
};

export const getStoreAdminDetail = async (storeId: number) => {
  const response = await instance.get(`/store-admin/stores/${storeId}`);
  return response.data;
};

export const patchStoreName = async (storeId: number, storeName: string) => {
  await instance.patch(`/store-admin/stores/${storeId}/name`, { storeName });
};

export const patchBusinessNum = async (storeId: number, businessNum: string) => {
  await instance.patch(`/store-admin/stores/${storeId}/business-num`, { businessNum });
};

export const resetStorePassword = async (storeId: number, userId: number) => {
  const response = await instance.post(
    `/store-admin/stores/${storeId}/managers/${userId}/reset-password`,
  );
  return response.data;
};

export const moveStoreDevices = async (
  storeId: number,
  targetStoreId: number,
  deviceIds: number[],
) => {
  const response = await instance.post(`/store-admin/stores/${storeId}/devices/move`, {
    targetStoreId,
    deviceIds,
  });
  return response.data;
};

export const previewDeviceExcel = async (file: File) => {
  const form = new FormData();
  form.append('file', file);
  const response = await instance.post('/store-admin/devices/excel/preview', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const saveDeviceExcel = async (file: File) => {
  const form = new FormData();
  form.append('file', file);
  const response = await instance.post('/store-admin/devices/excel', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
};

export const getDeviceExcelLogs = async () => {
  const response = await instance.get('/store-admin/devices/excel/logs');
  return response.data;
};

export const getStoreAdminPermissions = async () => {
  const response = await instance.get('/store-admin/permissions');
  return response.data;
};

export const saveStoreAdminPermission = async (body: {
  loginId: string;
  canRead: boolean;
  canUpdate: boolean;
  canDelete: boolean;
}) => {
  await instance.post('/store-admin/permissions', body);
};

export const searchMasterUsers = async (loginId: string) => {
  const response = await instance.get('/master/user-list', {
    params: { page: 1, 'login-id': loginId, 'phone-number': '' },
  });
  return response.data;
};

export const deleteStoreGroup = async (groupId: number) => {
  await instance.delete(`/store-admin/groups/${groupId}`);
};

export const renameStoreGroup = async (groupId: number, groupName: string) => {
  await instance.patch(`/store-admin/groups/${groupId}`, { groupName });
};

export const getStoreGroups = async () => {
  const response = await instance.get('/store-admin/groups');
  return response.data;
};

export const assignStoresToGroup = async (groupId: number, storeIds: number[]) => {
  const response = await instance.post(`/store-admin/groups/${groupId}/stores`, { storeIds });
  return response.data;
};

export const createStoreGroup = async (groupName: string) => {
  await instance.post('/store-admin/groups', { groupName });
};
